import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { refreshTokenStudent } from "../redux/authStudent/operation.js";
import { setStudentRefreshComplete } from "../redux/authStudent/slice.js";
import { selectStudentIsLoggedIn } from "../redux/authStudent/selector.js";

import { getInitialRole } from "../utils/getInitialRole.js";

const useStudentAuthInit = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isLoggedIn = useSelector(selectStudentIsLoggedIn);
  const hasAttemptedRef = useRef(false);

  // ⛔ Если активна другая роль — не делать refresh

  useEffect(() => {
    const role = getInitialRole();

    if (role === "teacher" || role === null) {
      dispatch(setStudentRefreshComplete());
      return;
    }
    const skipRefreshRoutes = [
      "/verify-teacher-email",
      "/verify-student-email",
      "/reset-password",
    ];

    if (skipRefreshRoutes.includes(location.pathname)) {
      dispatch(setStudentRefreshComplete());
      return;
    }

    if (hasAttemptedRef.current) return;

    const init = async () => {
      hasAttemptedRef.current = true;

      try {
        if (!isLoggedIn) {
          await dispatch(refreshTokenStudent()).unwrap();
        }
        // eslint-disable-next-line no-unused-vars
      } catch (_) {
        // ignore
      } finally {
        dispatch(setStudentRefreshComplete());
      }
    };

    init();
  }, [dispatch, isLoggedIn, location.pathname]);
};

export default useStudentAuthInit;
